export enum CATEGORIES {
  ACTIVITY = 'Activity',
  PROTRACK = 'ProTrack',
}

export enum PROTRACK_ACTIONS {
  FINISHED = 'finished',
  STARTED = 'started',
  STOPPED = 'stopped',
}
